import { searchPatients } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type {
  CareSearchPatientsRequestT,
  CareSearchPatientsResponseT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchCareSearchPatients(
  request: CareSearchPatientsRequestT,
  signal?: AbortSignal
): Promise<CareSearchPatientsResponseT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await searchPatients(request, config);
  return lotusHealthZod.searchPatientsResponse.parse(response.data) as CareSearchPatientsResponseT;
}
